import menu from "./lib/menu";
import animadoAlAparecer from "./lib/animado-al-aparecer";
import formulario from "./lib/formulario";
import salirRapido from "./uvm/salir-rapido";
import preguntasFrecuentes from "./uvm/preguntas-frecuentes";
import video from "./uvm/video";
require('../sass/app.scss');
var ajustaVw = function () {
    document.documentElement.style.setProperty('--vw', "".concat(document.documentElement.clientWidth, "px"));
};
var dataLayer = window.dataLayer;
salirRapido();
preguntasFrecuentes();
video();
addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
menu();
animadoAlAparecer('.animado', 50);
formulario('form', {
    dataLayer: dataLayer,
    ocultarEtiquetas: true
});
